import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';

export type ConnectivityQuality = 'GOOD' | 'WEAK' | 'POOR' | 'CHECKING';

@Injectable({
  providedIn: 'root'
})
export class ConnectivityService {
  private qualitySubject = new BehaviorSubject<ConnectivityQuality>('CHECKING');
  public quality$ = this.qualitySubject.asObservable();

  constructor() {}

  async checkQuality(): Promise<ConnectivityQuality> {
    this.qualitySubject.next('CHECKING');
    
    // 1. Check offline status
    if (!navigator.onLine) {
      this.qualitySubject.next('POOR');
      return 'POOR';
    }

    // 2. Check Network Information API (if available)
    const nav = navigator as any;
    const connection = nav.connection || nav.mozConnection || nav.webkitConnection;
    
    if (connection) {
      const { effectiveType, rtt, downlink } = connection;
      
      // Modern logic based on Effective Type and RTT
      if (effectiveType === '4g' && rtt < 200) {
        this.qualitySubject.next('GOOD');
        return 'GOOD';
      } else if (effectiveType === '3g' || rtt > 500) {
        this.qualitySubject.next('WEAK');
        return 'WEAK';
      } else {
        this.qualitySubject.next('POOR');
        return 'POOR';
      }
    }

    // 3. Fallback: If API not supported, assume GOOD if onLine
    this.qualitySubject.next('GOOD');
    return 'GOOD';
  }

  get currentQuality(): ConnectivityQuality {
    return this.qualitySubject.value;
  }
}
